import { Switch as BaseSwitch } from "@base-ui-components/react/switch";
import styled from "@mui/material/styles/styled";
import { useParentBg } from "../../shared/hooks/current-color";
const SwitchStyled = styled(BaseSwitch.Root)(({
  theme,
  switchSize
}) => {
  const parentBg = useParentBg();
  const palette = theme.palette[parentBg];
  const brandBackground = palette.brandBackground;
  const transparent = palette.transparent;
  const transparentHover = palette.hover;
  const disable = palette.disable;
  const switchRootWidth = theme.switch.size[switchSize].root.width;
  const switchRootHeight = theme.switch.size[switchSize].root.height;
  const switchRootPadding = theme.switch.size[switchSize].root.innerPadding;
  const switchRootBorderRadius = theme.switch.borderRadius[switchSize];
  return {
    width: switchRootWidth,
    height: switchRootHeight,
    borderRadius: switchRootBorderRadius,
    border: "none",
    background: transparent,
    padding: switchRootPadding,
    display: "flex",
    position: "relative",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: transparentHover
    },
    "&[data-checked]": {
      backgroundColor: brandBackground,
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: switchRootBorderRadius,
        backgroundColor: transparentHover,
        opacity: 0,
        pointerEvents: "none"
      },
      "&:not([data-disabled]):hover::after": {
        opacity: 1
      }
    },
    "&[data-disabled]": {
      backgroundColor: disable,
      cursor: "default"
    },
    "&[data-disabled]:hover": {
      backgroundColor: disable
    },
    "&[data-readonly]": {
      cursor: "default",
      "&:hover": {
        backgroundColor: transparent
      },
      "&[data-checked]:hover::after": {
        backgroundColor: brandBackground
      }
    }
  };
});
const SwitchThumbStyled = styled(BaseSwitch.Thumb)(({
  theme,
  switchSize
}) => {
  const parentBg = useParentBg();
  const palette = theme.palette[parentBg];
  const disable = palette.disable;
  const brandContrast = palette.brandContrast;
  const switchThumbSize = theme.switch.size[switchSize].thumb.width;
  return {
    width: switchThumbSize,
    height: switchThumbSize,
    borderRadius: "50%",
    backgroundColor: brandContrast,
    boxShadow: "none",
    transition: "translate 150ms ease",
    zIndex: "100",
    "&[data-checked]": {
      translate: "100%"
    },
    "&[data-disabled]": {
      background: disable
    }
  };
});
export {
  SwitchStyled,
  SwitchThumbStyled
};
